import React from 'react';
import { NavLink } from "react-router-dom";

import GlobalData from '../context/globaldata';

import { ReactComponent as IconDashboard } from "../images/icons/dashboard.svg";
import { ReactComponent as IconBrews } from "../images/icons/brews.svg";

export default class MobileNav extends React.Component {
  static contextType = GlobalData;

  state = {
    dropdown: false,
    brewsFilter: ''
  }

  toggleDropdown = () => {
    this.setState({
      dropdown: !this.state.dropdown
    })
  }

  applyFilter(filter) {
    this.context.setBrewsFilter(filter);
  }

  componentDidUpdate(prevProps, prevState) {

    if(prevState.brewsFilter !== this.context.brewsFilter) {
      this.setState({
        brewsFilter: this.context.brewsFilter
      })
    }
  }

  render() {

    if (this.context.userSettings && this.props.firebaseAuth.currentUser) {
      return (
        <nav className="mobile-navigation">
          <ul className="mobile-navigation__list">
            <li className="mobile-navigation__item">
              <NavLink exact={true} className="mobile-navigation__anchor" activeClassName='is-active' to='/'>
                <IconDashboard />
                <span>Dashboard</span>
              </NavLink>
            </li>

            <li className="mobile-navigation__item">
              <NavLink className="mobile-navigation__anchor" activeClassName='is-active' to='/brews' onClick={ () => { this.applyFilter('') } }>
                <IconBrews />
                <span>Brews</span>
                <span className="mobile-navigation__counter">{ this.context.brewAmountTotal }</span>
              </NavLink>
            </li>

            <li className="mobile-navigation__item">
              <NavLink className="mobile-navigation__anchor" activeClassName='is-active' to='/user' onClick={ () => { this.applyFilter('') } }>
                <i className="material-icons">settings</i>
                <span>Settings</span>
              </NavLink>
            </li>
          </ul>
        </nav>
      )
    } else {
      return null
    }
  }
}
